var React = require('react');

function Copy (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M25.1428 8.42868V25.143H8.42855V8.42868H25.1428ZM25.1428 6.57153H8.42855C7.93601 6.57153 7.46364 6.7672 7.11536 7.11548C6.76707 7.46376 6.57141 7.93613 6.57141 8.42868V25.143C6.57141 25.6355 6.76707 26.1079 7.11536 26.4562C7.46364 26.8044 7.93601 27.0001 8.42855 27.0001H25.1428C25.6354 27.0001 26.1078 26.8044 26.456 26.4562C26.8043 26.1079 27 25.6355 27 25.143V8.42868C27 7.93613 26.8043 7.46376 26.456 7.11548C26.1078 6.7672 25.6354 6.57153 25.1428 6.57153Z","fill":"#121212","stroke":"#121212","key":0}),React.createElement("path",{"d":"M2.85714 15.8571H1V2.85714C1 2.3646 1.19566 1.89223 1.54394 1.54394C1.89223 1.19566 2.3646 1 2.85714 1H15.8571V2.85714H2.85714V15.8571Z","fill":"#121212","stroke":"#121212","key":1})]);
}

Copy.defaultProps = {"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none"};

module.exports = Copy;

Copy.default = Copy;
